import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './IconButton2.module.css';

const IconButton = forwardRef(function IconButton(
  { type = 'button', variant, size, color, className, children, component: Component = 'button', ...rest },
  forwardedRef
) {
  return (
    <Component
      ref={forwardedRef}
      {...(Component === 'button' ? { type } : {})}
      className={classNames(styles.root, styles[variant], styles[color], styles[size], className)}
      {...rest}
    >
      {children}
    </Component>
  );
});

export default IconButton;
